function RateVariations() {
    return (
      <>
        <div className="font-bold text-xl text-blue-800 mb-16">Rate Variations</div>
      </>
    );
  }
  
  export default RateVariations;